module.exports = __webpack_public_path__ + "img/error_2.8e0967e6.svg";